export default [
    {
        title: 'Test and Test',
        customIcon: 'Survey',
        children: [
            {
                title: 'Test',
                route: 'test',
                path: '/test/test'
            },
        ]
    }
]